import { id } from "./id";
import type { OfferVariant } from "./offer_variant";
import type { OrderDetail } from "./order_detail";

export interface order_item_key {
    sellerId: number;
    buyerId: number;
    orderId: number;
    itemId: number;
    variantId: number;
}

export interface order_item extends order_item_key {
    id: string;
    couponId: number;
    name: string;
    quantity: number;
    price: number;
    discount: number;
    vat: number;
}

export interface OrderItem extends order_item {
    details: OrderDetail[];
}

export const orderItemToOfferVariant = (x: OrderItem): OfferVariant => ({ 
    id: id(x.sellerId, x.itemId),
    accountId: x.sellerId, 
    offerId: x.itemId, 
    variantId: x.itemId,
    name: x.itemId === 0 ? "Shipping" : x.name,
    details: x.details.map(x => x as any),
    price: x.price,
    quantity: x.quantity
}) as OfferVariant;